import { DEFAULT_LIMIT, DEFAULT_SKIP, LIMIT } from 'Src/consts/table';
import { Count } from 'Src/models/count';
import { superAdminGet } from './api';

export interface SuperAdminActionDescriptor {
  id: string;
  [key: string]: any;
  kind?: string;
  schoolId?: string;
  notificationMode?: string;
  notificationEmissionStatus?: string;
  affectedUserListStatus?: string;
  affectedAdminListStatus?: string;
  manualConfirmationStatus?: string;
  canEmitNotifications?: boolean;
  scheduledDate?: string;
  createdAt?: string;
  updatedAt?: string;
  eventId?: string;
  tournamentId?: string;
  programmeId?: string;
  additionalDescription?: string;
  affectedUserList?: any[];
  usersToNotifyList?: any[];
  triggeredBy?: any;
  details?: any;
  metadata?: any;
}

export interface SuperAdminActionDescriptorsFilter {
  limit?: number;
  skip?: number;
  order?: string;
  where?: any;
}

const DEFAULT_FILTER: SuperAdminActionDescriptorsFilter = {
  limit: LIMIT,
  skip: DEFAULT_SKIP,
  order: 'createdAt DESC'
};

function buildFilter(filter: SuperAdminActionDescriptorsFilter = DEFAULT_FILTER): SuperAdminActionDescriptorsFilter {
  return {
    where: filter.where || {},
    skip: typeof filter.skip === 'number' ? filter.skip : DEFAULT_FILTER.skip,
    limit: typeof filter.limit === 'number' ? filter.limit : DEFAULT_FILTER.limit,
    order: filter.order || DEFAULT_FILTER.order
  };
}

export function getSuperAdminSchoolActionDescriptors(
  schoolId: string,
  filter: SuperAdminActionDescriptorsFilter = DEFAULT_FILTER
): Promise<SuperAdminActionDescriptor[]> {
  return superAdminGet<SuperAdminActionDescriptor[]>('/actiondescriptors', {
    params: {
      filter: buildFilter({
        ...filter,
        where: {
          ...(filter.where || {}),
          schoolId
        }
      })
    }
  });
}

export function getAllSuperAdminSchoolActionDescriptors(
  schoolId: string,
  where?: any
): Promise<SuperAdminActionDescriptor[]> {
  return superAdminGet<SuperAdminActionDescriptor[]>('/actiondescriptors', {
    params: {
      filter: {
        where: {
          ...(where || {}),
          schoolId
        },
        skip: DEFAULT_SKIP,
        limit: DEFAULT_LIMIT,
        order: DEFAULT_FILTER.order
      }
    }
  });
}

export function getSuperAdminSchoolActionDescriptorsCount(schoolId: string, where?: any): Promise<Count> {
  return superAdminGet<Count>('/actiondescriptors/count', {
    params: {
      filter: {
        where: {
          ...(where || {}),
          schoolId
        }
      }
    }
  });
}

export function getSuperAdminActionDescriptor(actionDescriptorId: string): Promise<SuperAdminActionDescriptor> {
  return superAdminGet<SuperAdminActionDescriptor>(`/actionDescriptors/${actionDescriptorId}`);
}
